import { render, staticRenderFns } from "./index.vue?vue&type=template&id=317c7f1b&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=317c7f1b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317c7f1b",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlogPostCard: require('/opt/build/repo/components/BlogPostCard.vue').default,BlogFooterCta: require('/opt/build/repo/components/global/BlogFooterCta.vue').default})
